/* global window */

import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'

// Redux
import { connect } from 'react-redux'

//Base UI
import Popover from 'material-ui/Popover'
import FlatButton from 'material-ui/FlatButton'
import MiscUtils from './infra/MiscUtils'
import ReportHeader from './reports/common/ReportHeader'
import Analytics from './infra/analytics/Analytics'

import settingsGear from 'resources/settings_gear.png'
import fiboLogo from 'resources/fibo_logo.png'

class AppHeader extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    teamName: PropTypes.string.isRequired,
    member: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    let title = props.title
    if (title.indexOf('reports') === 0) {
      title = 'reports'
    }
    this.headerButtons = {}
    this.state = {
      title: title,
      teamName: props.teamName,
      reportSelection: false
    }
  }

  componentWillReceiveProps(nextProps) {
    let title = nextProps.title
    if (title.indexOf('reports') === 0) {
      title = 'reports'
    }
    this.setState({
      title,
      teamName: nextProps.teamName
    })
  }

  renderButton(title) {
    const isSelected = title === this.state.title
    const buttonColor = isSelected ? 'white' : 'rgba(255,255,255,0.75)'
    const selectorColor = isSelected ? 'rgba(255,255,255,0.33)' : 'transparent'

    return (
      <div ref={button => this.headerButtons[title] = button}>
        <FlatButton
          style={{height: 60, color: buttonColor}}
          labelStyle={{ fontSize: 13, fontWeight: 400, letterSpacing: 0.5 }}
          label={title.toUpperCase()}
          onTouchTap={() => {
            if (title === 'reports') {
              this.setState({
                reportSelection: true
              })
            } else {
              this.setState({ title })
              window.location = '#/app/' + title
            }
          }}/>

        <div style={{height: 4, backgroundColor: selectorColor}}/>
      </div>
    )
  }

  renderReportButton(reportName, reportRoute) {
    const isSelected = this.state.report === reportName
    const textColor = isSelected ? '#527da3' : 'rgba(0,0,0,0.55)'
    const selectorColor = isSelected ? '#527da3' : 'transparent'

    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <div style={{radius: 3, width: '4px', backgroundColor: selectorColor}}/>
        <FlatButton
          style={{flexGrow: 1, alignItems: 'flex-start'}}
          labelStyle={{ display: 'flex', color: textColor, textTransform: 'none'}}
          label={ReportHeader.Title[reportName]}
          onTouchTap={() => {
            this.setState({ reportSelection: false })
            window.location = '#/app/reports/' + reportRoute
            this.props.dispatch({
              type: 'REPORTS_TYPE',
              label: 'TYPE',
              value: reportName
            })
          }}/>
      </div>
    )
  }

  handleSettingsClicked = () => {
    this.setState({ title: 'settings' })
    window.location = '#/app/settings'
  }

  hasAccess = (member, route) => {
    if (member.access === 'admin') {
      return true
    }
    if (member.access === 'manager') {
      return [ 'messages', 'schedule', 'reports', 'team' ].includes(route)
    }
    return false
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <img src={fiboLogo} alt='Fibo' height={28} />
          <div style={styles.separator} />
          { this.hasAccess(this.props.member, 'messages') && this.renderButton('messages') }
          { this.hasAccess(this.props.member, 'customers') && this.renderButton('customers') }
          { this.hasAccess(this.props.member, 'schedule') && this.renderButton('schedule') }
          { this.hasAccess(this.props.member, 'estimates') && this.renderButton('estimates') }
          { this.hasAccess(this.props.member, 'invoices') && this.renderButton('invoices') }
          { this.hasAccess(this.props.member, 'reports') && this.renderButton('reports') }
          { this.hasAccess(this.props.member, 'team') && this.renderButton('team') }
        </div>

        <div style={styles.right}>
          { this.hasAccess(this.props.member, 'settings') &&
            <div style={styles.right}>
              <div style={styles.settings} title='Settings'
                onTouchTap={this.handleSettingsClicked}>
                <img src={settingsGear} width={24} height={24} alt=''/>
              </div>
              <div style={styles.separator} />
            </div>
          }
          <div style={{ cursor: 'pointer' }} title='Logout'
            onTouchTap={() => {
              firebase.auth().signOut()
              Analytics.track(Analytics.USER_SIGNED_OUT)
            }}>
            <div style={{ fontSize: 14, fontWeight: 400, letterSpacing: 0.5 }}>
              { this.state.teamName }
            </div>
          </div>
        </div>

        <Popover
          open={this.state.reportSelection}
          anchorEl={this.headerButtons['reports']}
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'left', vertical: 'top'}}
          onRequestClose={() => this.setState({ reportSelection: false })}>
          { this.renderReportButton('serviceSummary', 'service-summary') }
          { this.renderReportButton('timeAllocation', 'time-allocation') }
          { this.renderReportButton('payroll', 'payroll') }
        </Popover>
      </div>
    )
  }
}

const styles = {
  container: {
    display: 'flex',
    flexShrink: 0,
    height: 64,
    paddingLeft: 22,
    paddingRight: 22,
    alignItems: 'center',
    backgroundColor: MiscUtils.STAGE === 'prod' ? '#527da3' : '#717171',
    color: 'white',
    justifyContent: 'space-between'
  },
  right: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  separator: {
    width: 1,
    height: 32,
    opacity: 0.27,
    backgroundColor: '#bcccd8',
    marginLeft: 22,
    marginRight: 22
  },
  settings: {
    cursor: 'pointer',
    width: 24,
    height: 24
  }
}

export default connect(state => ({ teamName: state.firebase.team.metadata.value.displayName }))(AppHeader)



// WEBPACK FOOTER //
// ./src/AppHeader.js